<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Authority',
    props: {
        code: String, // 需要的权限
    },
    computed: {
        ...mapGetters([
        'Authorisations',
        ])
    },
    render() {
        const { $slots, Authorisations, code } = this
        const hasPermission = Authorisations.some(p => p === code)
        return hasPermission ? $slots.default : null
    }
}
</script>